module.exports = __webpack_public_path__ + "static/media/small-white-diamonds.f21796d5.svg";